import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';

import { AuthService } from '../core/service/auth.service';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule, RouterLink, MenuModule],
  templateUrl: './app.topbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTopBarComponent implements OnInit {
  readonly layoutService = inject(LayoutService);
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);

  accountMenuItems: MenuItem[] = [];

  @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;
  @ViewChild('topbarmenu') menu!: ElementRef;

  ngOnInit(): void {
    this.accountMenuItems = [
      {
        label: 'Account',
        items: [
          {
            label: 'Profile',
            icon: 'pi pi-user',
            routerLink: '/profile',
          },
          {
            label: 'Change password',
            icon: 'pi pi-key',
            routerLink: '/change-password',
          },
          {
            separator: true,
          },
          {
            label: 'Sign out',
            icon: 'pi pi-sign-out',
            command: () => this.signOut(),
          },
        ],
      },
    ];
  }

  private signOut(): void {
    this.authService
      .logout()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.authService.clearSession(),
        error: () => this.authService.clearSession(),
      });
  }
}
